module.exports = __webpack_public_path__ + "static/img/lpa_svg_title.570de3ab.svg";